import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import {
  getNotifications,
  markAllAsRead,
} from '../../store/actions/Notification';
import { NotificationPagination } from '../../components/';

class Notification extends Component {
  constructor(props) {
    super(props);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this.loadNotifications();
    this.props.dispatchCheckAllNotificationsAsRead();
  }

  loadNotifications() {
    const { notifications, dispatchGetNotifications } = this.props;
    if (isEmpty(notifications)) {
      dispatchGetNotifications();
    }
  }

  handlePageChange(e, { activePage: page }) {
    const { dispatchGetNotifications } = this.props;
    dispatchGetNotifications({ page });
  }

  render() {
    const { notifications, pagination } = this.props;

    return (
      <NotificationPagination
        notifications={notifications}
        pagination={pagination}
        handlePageChange={this.handlePageChange}
      />
    );
  }
}

const mapStateToProps = state => {
  const { notifications, pagination, isNewNotifications } = state.notification;
  return {
    notifications,
    pagination,
    isNewNotifications,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatchGetNotifications: params => dispatch(getNotifications(params)),
  dispatchCheckAllNotificationsAsRead: () => dispatch(markAllAsRead()),
});

Notification.propTypes = {
  dispatchCheckAllNotificationsAsRead: PropTypes.func,
  dispatchGetNotifications: PropTypes.func,
  notifications: PropTypes.array,
  pagination: PropTypes.object,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Notification);



// WEBPACK FOOTER //
// ./src/containers/Notification/Notification.js